import { jsx as _jsx } from "react/jsx-runtime";
import { useRetrievePlayer, useRetrieveUserPlayerPermissions, } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import { useNumericParams } from "../utils/useNumericParams";
import { PlayerPage } from "./PlayerPage";
export var Player = function () {
    var id = useNumericParams().id;
    var _a = useRetrieveUserPlayerPermissions({ playerId: id }), userPlayerPermissions = _a.data, userPlayerPermissionsIsLoading = _a.isLoading, userPlayerPermissionsError = _a.error;
    var _b = userPlayerPermissions || {}, _c = _b.canModify, canModify = _c === void 0 ? false : _c, _d = _b.canView, canView = _d === void 0 ? false : _d, _e = _b.canViewTeams, canViewTeams = _e === void 0 ? false : _e;
    var _f = useRetrievePlayer({ id: id }), isLoading = _f.isLoading, error = _f.error, player = _f.data;
    if (error || userPlayerPermissionsError) {
        return _jsx(ErrorView, { error: error });
    }
    if (isLoading || userPlayerPermissionsIsLoading) {
        return _jsx(Loading, {});
    }
    if (!player || !userPlayerPermissions) {
        return _jsx(ErrorView, { error: new Error("Cannot load all data") });
    }
    if (!canView) {
        return _jsx(NotFound, {});
    }
    return (_jsx(PlayerPage, { player: player, canViewTeams: canViewTeams, canModify: canModify }));
};
